export default "__VITE_ASSET__9acQAMo___"